import React from "react";
import { Badge } from "@mui/material";
import { MenuBarTabsContainer, TabItem } from "./Tabs.style";

interface TabItemType {
  index: number;
  icon: React.ReactNode;
  label: string;
  dataTestId: string;
  invisible?: boolean;
}

interface TabsProps {
  tabs: TabItemType[];
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const Tabs = ({ tabs, value, onChange }: TabsProps) => {
  return (
    <MenuBarTabsContainer
      slotProps={{
        indicator: { style: { display: "none" } },
      }}
      value={value}
      onChange={onChange}
      aria-label="tabs"
      variant="fullWidth"
    >
      {tabs.map((tab, index) => (
        <TabItem
          icon={
            <Badge sx={{ marginY: "6px" }} invisible={tab.invisible || false}>
              {tab.icon}
            </Badge>
          }
          key={index}
          label={tab.label}
          data-testid={tab.dataTestId}
        />
      ))}
    </MenuBarTabsContainer>
  );
};

export default Tabs;
